import React, { useState } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    TextField,
} from '@mui/material';

import Box from 'elements/Box';
import { ProjectConfig } from 'Global';

export default function FormChangePass( props: any ) {
    
    const {
        logo,
        setState,
        email,
        code
    } = props;

    /*================================================
    SNACKBAR FUNCTION FOR NOTIFICATIONS
    ================================================*/
    const { enqueueSnackbar } = useSnackbar();
    /*============================================= */

    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');

    const [loading, setLoading] = React.useState(false);
    /*================================================
    CHANGE PASSWORD (SUBMIT)
    ================================================*/
    const handleSubmit = () => {
        if(password !== confirmPassword){
            enqueueSnackbar("Passwords do not match", { variant: 'error' });
            return;
        }
        setLoading(true);
        axios.get(ProjectConfig.api_url+"/users/change_password", {
            params: {
                email: email,
                code: code,
                password
            },
        })
        .then((response) => {
            if(response.data.status === "success"){
                enqueueSnackbar(response.data.message, { variant: 'success' });
                setState('login');
            } else {
                enqueueSnackbar(response.data.message, { variant: 'error' });
            }
        })
        .catch((error) => {
            enqueueSnackbar(error.toString(), { variant: 'error' });
        })
        .finally(() => {
          setLoading(false);
        });
    };
    /*================================================
    ================================================*/

    return(
        <Box id='loginBox' className='intent-auth_component'>

          <img className='loginLogo' src={logo} alt="" />

            <TextField
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="newPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              required
              fullWidth
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={password !== confirmPassword && confirmPassword !== '' ? true : false}
              helperText={password !== confirmPassword && confirmPassword !== '' ? "Passwords do not match" : ''}
            />
            
            <LoadingButton
              size="small"
              type="submit"
              loading={loading}
              fullWidth
              variant="contained"
              sx={{ fontSize: '13px', padding: '10px 0px'}}
              onClick={handleSubmit}
            >
              Change Password
            </LoadingButton>

        </Box>
    );
}